<template>
  <div class="content-box">
    <p class="little-title">{{ $t('serviceTerms') }}</p>
    <p class="list">{{ $t('acceptTermsDes') }}</p>
    <p>{{ $t('acceptTermsDescribe') }}</p>

    <p class="little-title">{{ $t('usagePolicy') }}</p>
    <p class="list">{{ $t('usagePolicyDes') }}</P>
    <p class="list">{{ $t('usagePolicyExplain') }}</p>
    <p class="list">{{ $t('usagePolicyDescribe') }}</p>
    <p class="account-lists" v-for="(duty, index) in $t('dutyList')">
      <span class="index"></span>{{ duty }}
    </p>
    <p class="violations">{{ $t('violations') }}</p>

    <p class="little-title">{{ $t('termsChange') }}</p>
    <p>{{ $t('termsChangeDes') }}</p>
  </div>
</template>

<script>
  import locales from './lang'
  import HomeFooter from '../../components/footer/Footer.vue'

  export default {
    name: 'privacy-terms-page',
    locales,
    components: {
      HomeFooter
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .content-box {
    max-width: 1180px;
    margin: -.8rem auto 1.8rem;
  }

  p {
    font-size: .16rem;
    color: #111;
    letter-spacing: 0;
    line-height: .22rem;
  }

  .little-title {
    font-size: .32rem;
    font-weight: 600;
    color: #333;
    letter-spacing: 0;
    margin-bottom: .24rem;
    margin-top: .64rem;
    line-height: .48rem;
    &:first-child {
      margin-top: 0;
      color: #111;
      font-size: .4rem;
      line-height: .4rem;
    }
  }

  .list {
    margin-bottom: .24rem;
  }

  .account-lists {
    margin-bottom: .16rem;
    span.index {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #333;
      margin-right: .08rem;
      position: relative;
      top: -.02rem;
    }
  }
  
  .violations {
    padding-top: .08rem;
  }
    
  @media (max-width: 1228px) {
    .content-box {
      padding: 0 24px;
    }
  }
  @media (max-width: 991px) {
    .content-box {
      margin: -.4rem auto .8rem;
    }
    .little-title {
      font-size: 20px;
      color: #111111;
      line-height: 28px;
      margin-bottom: .08rem;
      margin-top: .24rem;
      &:first-child {
        margin-top: 0;
        font-size: 24px;
        line-height: 32px;
      }
    }
    p {
      font-size: 14px;
      color: #666666;
      line-height: 20px;
    }
    .list {
      margin-bottom: .16rem;
    }
    .account-lists {
      margin-bottom: .12rem;
      span.index {
        width: 6px;
        height: 6px;
        margin-right: .05rem;
      }
    }
    .violations {
      padding-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// PrivacyService.vue?00bc1e59